var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInRouteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 12.5,
    cy: 6.5,
    r: 6.5,
    fill: "#9BBEFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 15.125C4.08152 15.125 4.39946 14.9933 4.63388 14.7589C4.8683 14.5245 5 14.2065 5 13.875C5 13.5435 4.8683 13.2255 4.63388 12.9911C4.39946 12.7567 4.08152 12.625 3.75 12.625C3.41848 12.625 3.10054 12.7567 2.86612 12.9911C2.6317 13.2255 2.5 13.5435 2.5 13.875C2.5 14.2065 2.6317 14.5245 2.86612 14.7589C3.10054 14.9933 3.41848 15.125 3.75 15.125V15.125Z",
    stroke: "#9BBEFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 6.375C11.5815 6.375 11.8995 6.2433 12.1339 6.00888C12.3683 5.77446 12.5 5.45652 12.5 5.125C12.5 4.79348 12.3683 4.47554 12.1339 4.24112C11.8995 4.0067 11.5815 3.875 11.25 3.875C10.9185 3.875 10.6005 4.0067 10.3661 4.24112C10.1317 4.47554 10 4.79348 10 5.125C10 5.45652 10.1317 5.77446 10.3661 6.00888C10.6005 6.2433 10.9185 6.375 11.25 6.375V6.375Z",
    stroke: "#9BBEFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 13.875H10.3125C10.5998 13.875 10.8842 13.8184 11.1496 13.7085C11.415 13.5986 11.6562 13.4374 11.8593 13.2343C12.0624 13.0312 12.2236 12.79 12.3335 12.5246C12.4434 12.2592 12.5 11.9748 12.5 11.6875C12.5 11.4002 12.4434 11.1158 12.3335 10.8504C12.2236 10.585 12.0624 10.3438 11.8593 10.1407C11.6562 9.93758 11.415 9.77645 11.1496 9.66651C10.8842 9.55658 10.5998 9.5 10.3125 9.5H5.3125C4.73234 9.5 4.17594 9.26953 3.7657 8.8593C3.35547 8.44906 3.125 7.89266 3.125 7.3125C3.125 6.73234 3.35547 6.17594 3.7657 5.7657C4.17594 5.35547 4.73234 5.125 5.3125 5.125H7.5",
    stroke: "#9BBEFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInRouteIcon);
export default __webpack_public_path__ + "static/media/inRouteIcon.8591e6b773937eea93360eeb84d99eb6.svg";
export { ForwardRef as ReactComponent };